export class DuplicateEmailError extends Error {
  constructor(email: string) {
    super(`Duplicate email: ${email}`);
  }
}
